import React from 'react';
import { FinalCTA } from '../components/FinalCTA';
import { PageIntro } from '../components/PageIntro';
import { StayFAQ } from '../components/StayFAQ';
import { StayOnTheLand } from '../components/StayOnTheLand';
import { TrustDiscovery } from '../components/TrustDiscovery';
export function StaysPage() {
  return <>
      <PageIntro eyebrow="Stay Overnight" title="Stay on the land, not just near it." description="Make the reset last overnight in a private retreat stay near Pardes Hanna — a comfortable base for rest, nature, and the rhythm of the land." data-id="element-450" data-mp="6bkp6t94admr" />
      <StayOnTheLand data-id="element-451" data-mp="kb2klrgx4p53" />
      <StayFAQ data-id="element-452" data-mp="k9rfnobqlbce" />
      <TrustDiscovery data-id="element-453" data-mp="ka14v9oyjeh1" />
      <FinalCTA data-id="element-454" data-mp="k8q2neb5ues1" />
    </>;
}